import { prefersReducedMotion } from '@theme/utilities';

class ScrollAnimator extends HTMLElement {
  connectedCallback() {
    this.classList.add('ready');

    if (this.dataset.animationEffect && this.dataset.animationEffect !== 'none' && !prefersReducedMotion()) {
      if (this.firstElementChild) {
        this.#init();
      } else {
        const observer = new MutationObserver(() => {
          if (this.firstElementChild) {
            observer.disconnect();
            this.#init();
          }
        });
        observer.observe(this, { childList: true });
      }
    }
  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  #init() {
    if (this.dataset.animationEffect === 'reveal' && this.dataset.splitText === 'true') {
      this.#splitContent();
    }
    this.#setIntersectionObserver();
  }

  #setIntersectionObserver() {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('jumbo-text-visible');
            if (this.dataset.animationRepeat === 'false') {
              this.intersectionObserver.unobserve(entry.target);
            }
          } else {
            this.classList.remove('jumbo-text-visible');
          }
        });
      },
      { rootMargin: '0px 0px -25% 0px' }
    );

    const target = this.firstElementChild || this;
    this.intersectionObserver.observe(target);
  }

  #splitContent() {
    const treeWalker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, null, false);
    const textNodes = [];
    let currentNode;
    while ((currentNode = treeWalker.nextNode())) {
      textNodes.push(currentNode);
    }

    let lineIndex = 1;

    textNodes.forEach(node => {
      const text = node.nodeValue;
      if (!text.trim()) return;

      const fragment = document.createDocumentFragment();
      const chars = text.split('');

      chars.forEach(char => {
        // Shopify rich text editor often injects invisible zero-width characters
        if (/[\u200B\uFEFF\u200C\u200D]/.test(char)) return;

        if (char.trim() === '') {
          const space = document.createElement('span');
          space.className = 'jumbo-text-space';
          space.setAttribute('aria-hidden', 'true');
          space.textContent = char;
          fragment.appendChild(space);
        } else {
          const charSpan = document.createElement('span');
          charSpan.className = 'jumbo-text-char';
          charSpan.style.setProperty('--line-index', String(lineIndex));
          charSpan.setAttribute('aria-hidden', 'true');

          const innerSpan = document.createElement('span');
          innerSpan.className = 'jumbo-text-char-inner';
          innerSpan.textContent = char;

          charSpan.appendChild(innerSpan);
          fragment.appendChild(charSpan);
        }
      });
      node.parentNode.replaceChild(fragment, node);
    });
  }
}

if (!customElements.get('scroll-animator')) {
  customElements.define('scroll-animator', ScrollAnimator);
}
